import Nullstack from 'nullstack';
export default function IconSunset2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sunset-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 13h1"
  }), "   ", Nullstack.element("path", {
    d: "M20 13h1"
  }), "   ", Nullstack.element("path", {
    d: "M5.6 6.6l.7 .7"
  }), "   ", Nullstack.element("path", {
    d: "M18.4 6.6l-.7 .7"
  }), "   ", Nullstack.element("path", {
    d: "M8 13a4 4 0 1 1 8 0"
  }), "   ", Nullstack.element("path", {
    d: "M3 17h18"
  }), "   ", Nullstack.element("path", {
    d: "M7 20h5"
  }), "   ", Nullstack.element("path", {
    d: "M16 20h1"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v-1"
  }), " ");
}